import React from 'react';
import { SOURCE_URL } from '../../../config';
import { useInView } from 'react-intersection-observer';
import 'animate.css';
import { animationClass, animationStyle } from '../../../utils/FadeInEffect';
import { useAppDispatch } from '../../../stores/hook';
import { setPackInfoDetailStatus } from '../GetStarted/GetStartedSlice';

interface AdvertiserButtonLayoutProps {
    element: any
}

const AdvertiserButtonLayout: React.FC<AdvertiserButtonLayoutProps> = (element) => {
    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });
    const dispatch = useAppDispatch();

    const openChannel = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        dispatch(setPackInfoDetailStatus(true));
    }
    
    return (
        <>
        <div ref={ref} className={`col-lg-6 columned-item mb-4 text-center ${animationClass(inView, 'up')}`}  style={animationStyle(inView,'up')} >
            <div className="h-100 advertisement-column hid-overflow mb-5">
                <div className="img-wrap aspect-ratio advertiser-img">
                    <img className="img-fit lazyloaded" src={SOURCE_URL + element?.element?.ContentImage?.data?.attributes?.url} />
                    <noscript><img src={SOURCE_URL + element?.element?.ContentImage?.data?.attributes?.url} className='img-fit'/></noscript>
                </div>
                <h5 className="font-weight-bold py-4 my-3 px-3">{element?.element?.ContentTitle}</h5>
                {element?.element?.ButtonLink?.URL &&
                <p>
                    {element?.element?.ButtonLink?.URL == "#popup-channels" ? 
                    <a className="default-btn" href={element?.element?.ButtonLink?.URL} onClick={openChannel}>{element?.element?.ButtonLink?.LinkText}</a>
                    :<a className="default-btn" href={element?.element?.ButtonLink?.URL} target={element?.element?.ButtonLink?.OpenLinkInANewTab ? '_blank' : '_self'}>{element?.element?.ButtonLink?.LinkText}</a>}
                </p>}
                {element?.element?.SecondLink?.URL &&
                <p>
                    <a className="color-1 barlow-font" href={element?.element?.SecondLink?.URL} target={element?.element?.SecondLink?.OpenLinkInANewTab ? '_blank' : '_self'}>{element?.element?.SecondLink?.LinkText}</a>
                </p>}
            </div>
        </div>
        </>
    );
};

export default AdvertiserButtonLayout;
